import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { preloadCriticalResources, addResourceHints } from './utils/performance';
import { inject } from '@vercel/analytics';
import { Analytics } from '@vercel/analytics/react';

// Add resource hints for better performance
addResourceHints();

// Preload critical resources
preloadCriticalResources();

// Initialize Vercel Analytics (no-op locally; automatically works on Vercel)
inject();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>
);

// Performance monitoring
reportWebVitals(console.log);

// Additional performance monitoring
if (process.env.NODE_ENV === 'development') {
  // Monitor Core Web Vitals
  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      console.log(`${entry.name}: ${entry.value}`);
    }
  });
  
  observer.observe({ entryTypes: ['navigation', 'resource', 'paint'] });
}
